  import { DomUtils } from '@zm-biz/zm-biz-utils';
  import { TYPE, EMIT, NAME, TIPTIME } from '../config';
  require('./main.scss');
  
  export default {
    name: NAME,

    props: {
      type: {
        type: String,
        default: TYPE.alert
      },
      text: {
        type: String,
        default: ''
      },
      show: {
        type: Boolean,
        default: false
      }
    },

    watch: {
      show(v) {
        if (!!v) {
          DomUtils.touchDisable();
        }else {
          DomUtils.touchEable();
        }
      }
    },

    methods: {
      confirmConfirm() {
        this.$emit(EMIT.confirm);
      },
      cancelConfirm() {
        this.$emit(EMIT.cancel);
      },
      confirmAlert() {
        this.$emit(EMIT.alert);
      },
      createTip() {
        return <transition name="fade">
                  <div class="mg-dialog__tip info">
                    <span class="text"> {this.text} </span>
                  </div>
                </transition>;
      },
      addCloseTipEvent() {
        window.setTimeout(() => {
          this.$emit(EMIT.tip);
        }, TIPTIME);
      }
    },
    
    render: function (h) {
      if (this.show == false) {
        return (<div></div>);
      }
      if (this.type == TYPE.tip) {
        this.addCloseTipEvent();
        return (this.createTip());
      }
      let control = null;
      switch (this.type) {
        case TYPE.alert:
          control = <div class="mg-dialog__control">
                      <span onClick={this.confirmAlert} class="mg-dialog__control__alert">确定</span>
                    </div>;
          break;
        case TYPE.confirm:
            control = <div class="mg-dialog__control">
                        <span onClick={this.cancelConfirm} class="mg-dialog__control__cancel">取消</span>
                        <span onClick={this.confirmConfirm} class="mg-dialog__control__confirm">确定</span>
                      </div>;
          break;
      }
      return (
        <div id="mg-dialog__main" class="mg-dialog__main">
          <div class="mg-dialog__content">
            <div class="mg-dialog__message">
              <span> {this.text} </span>
            </div>
            {control}
          </div>
        </div>
      )
    }
}